import React, { useContext, useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { ResponsiveContext, Layer, Spinner, Page, PageContent, PageHeader, Button, Box } from 'grommet'
import { useParams } from "react-router-dom";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ReverseAnchor } from '../components/competetive/ReverseAnchor';
import { competetiveActions } from "../redux/actions/competetiveActions";
import { CompetetiveProductsGrid } from '../components/competetive/CompetetiveProductsGrid';
import { competetiveService } from '../services';
import { CompetitiveSinlgeClickGrid } from '../components/competetive/CompetitiveSingleClickGrid';
import { checkUserCompetitorFollow, userCompetitorFollowUnfollow } from '../redux/actions/notificationActions';
import { CircularProgress } from '@material-ui/core';
import { Checkmark } from 'grommet-icons';

function CompetitorProductListPage({ props }) {
    const [isSinlgeClick, setIsSinlgeClick] = useState(false)
    const size = useContext(ResponsiveContext);
    const dispatch = useDispatch();
    const { id, name } = useParams();

    const session = useSelector((state) => {
        return state.session;
    });
    const [selectedCompetitor, setSelectedCompetitor] = useState()
    useEffect(() => {
        if (session && session.user && session.user.access && window.location.href.indexOf("tools") > -1) {
            setIsSinlgeClick(true)
            dispatch(competetiveActions.getSingleClickResource(id, session.user.access));
        }
        if (session && session.user && session.user.access) {
            dispatch(competetiveActions.getCompetitorProducts(id, session.user.access));
            dispatch(checkUserCompetitorFollow(session.user.access, id))
            competetiveService.getCompetitorById(session.user.access, id).then((response) => setSelectedCompetitor(response.competitor_name))
        }
    }, [session, id, dispatch]);



    const competitorProductList = useSelector((state) => {
        return state.competitiveProducts.competitorProducts
    });
    const singleClickList = useSelector((state) => {
        return state.competitiveProducts.singelClickResource
    });
    const isFollowing = useSelector((state) => state.notification.isFollowing)
    const followRequestInProgress = useSelector((state) => state.notification.followRequestInProgress)
    const history = useHistory();

    function onFollowButtonClickHandler() {
        dispatch(userCompetitorFollowUnfollow(session.user.access, isFollowing, id))
    }
    return (
        <>
            <Page>
                <PageContent gap='medium'>
                    {isSinlgeClick ? <>
                        {singleClickList.requestInProgress && (<Layer position='center' background='none' style={{ boxShadow: "none" }}>
                            <Spinner />
                        </Layer>)}
                        {singleClickList.data &&
                            <>
                                <PageHeader
                                    parent={<ReverseAnchor label={"Competitors"} onClick={() => { window.history.go(-1) }} />}
                                    title={isSinlgeClick ? name : selectedCompetitor}
                                // actions={<> <Box>
                                //     {isFollowing && !isFollowing.subscribed ? <Button secondary label="Subscribe" onClick={() => {
                                //         dispatch(userCompetitorFollowUnfollow(session.user.access, isFollowing.subscribed, id)).then((response) => {
                                //             console.log(response)
                                //         })
                                //     }} /> : <Button label="Unsubscribe" onClick={() => { dispatch(userCompetitorFollowUnfollow(session.user.access, isFollowing.subscribed, id)) }} />}
                                // </Box></>}
                                />
                                {/* <Box width={"medium"}>
                        <StyledTextInput icon={<Search id="search-icon" color="placeholder" />} placeholder="Search" reverse value={searchValue} onChange={event => setSearchValue(event.target.value)} type="search" />
                    </Box> */}
                                {
                                    <CompetitiveSinlgeClickGrid productsList={singleClickList.data} singelClickId={id} history={history} size={size} />
                                }
                            </>
                        }
                    </> : <>   {
                        competitorProductList.requestInProgress && (<Layer position='center' background='none' style={{ boxShadow: "none" }}>
                            <Spinner />
                        </Layer>)}
                        {competitorProductList.data &&
                            <>
                                <PageHeader parent={<ReverseAnchor label={"Competitors"} onClick={() => { window.history.go(-1) }} />} title={isSinlgeClick ? name : selectedCompetitor} actions={<> <Box>
                                    {
                                        followRequestInProgress ? <CircularProgress /> : isFollowing
                                            ? <Button label="Following" icon={<Checkmark />} onClick={onFollowButtonClickHandler} tip="Click to stop notifications for this competitor" a11yTitle="Following, click to unfollow" />
                                            : <Button label="Follow" onClick={onFollowButtonClickHandler} secondary tip="Get notified when new resources are added for this competitor" />
                                    }
                                </Box></>}
                                />
                                {
                                    <CompetetiveProductsGrid productsList={competitorProductList.data} competitorId={id} history={history} size={size} />
                                }
                            </>
                        }</>}
                </PageContent>
            </Page>
        </>
    )
}

export default CompetitorProductListPage